// extracted by mini-css-extract-plugin
export default {"resultsPage":"ylFwCJ","noInsights":"bRgmCK","centeredContent":"E0URyK","sidePanel":"ZktSZI"};